import { render, staticRenderFns } from "./domainName.vue?vue&type=template&id=7ea015e4&"
import script from "./domainName.vue?vue&type=script&lang=js&"
export * from "./domainName.vue?vue&type=script&lang=js&"
import style0 from "./domainName.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports